import { forwardRef } from 'react';

type MoreItemsIndicatorProps = {
  count: number;
};

export const MoreItemsIndicator = forwardRef<
  HTMLDivElement,
  MoreItemsIndicatorProps
>(({ count }, ref) => {
  return (
    <div ref={ref} className="flex items-center gap-1.5">
      <div className="h-2 w-2 shrink-0 rounded-[2px] bg-gray-400" />
      <span className="text-xs">And +{count} more</span>
    </div>
  );
});

MoreItemsIndicator.displayName = 'MoreItemsIndicator';
